import { render, staticRenderFns } from "./appPolicy.vue?vue&type=template&id=bbe05d90"
import script from "./appPolicy.vue?vue&type=script&lang=js"
export * from "./appPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports